module.exports = __webpack_public_path__ + "static/trees-ac216da4e6b7fe4b787a169eeb02dbb0.png";